<div class="top-routes">
    <div class="topology-map">
        <choose-topology-item-container [diagramId]="'top-5-routes'"
                                        [options]="mapOptions"
                                        (onClick)="onMapClick($event)"
                                        (onReady)="onTopologyReady()">
        </choose-topology-item-container>
    </div>
    <div class="routes-labels">
        <div class="routes-label" *ngFor="let route of topRoutesColors; let i = index" [style]="'color: ' + getRouteColor(route)"
        (click)="route.display = !route.display; updateTopologyMap()">
            <span class="label-name">ROUTE {{i + 1}}</span>
            <div class="route-indication" [style]="'background: ' + getRouteColor(route)"></div>
        </div>
    </div>
</div>
